import angular, { IScope } from 'angular';
import {
    FilterService2,
    FontFamilyService,
    LicenseType,
} from '../../tn.common';
import {
    DjangoLicenseType,
    IDjangoApi1License,
    filterLicensesToType,
    hasLimitedLicense,
    hasNonPerpetualLicense,
    hasUpgradeableLicense,
    hasWebLicenseSelfHosted,
} from '../../tn.common/classes/Model/Licenses';
import { allAreUnpaid } from '../../tn.licenses/has-license-type.filter/all-are-unpaid';
import { hasAnyOfLicenseType } from '../../tn.licenses/has-license-type.filter/has-any-of-license-type';
import { hasBeenPaid } from '../../tn.licenses/has-license-type.filter/has-been-paid';
import { hasFurtherUpgrades } from '../../tn.licenses/has-license-type.filter/has-further-upgrades';
import { hasLicenseType } from '../../tn.licenses/has-license-type.filter/has-license-type';
import { hasLimitedQty } from '../../tn.licenses/has-license-type.filter/has-limited-qty';
import { hasSelfHostedLicenseList } from '../../tn.licenses/has-license-type.filter/has-self-hosted-license-list';
import { LicenseService } from '../../tn.licenses/license.service/license-service';
import { PopoverService } from '../../tn.popover/service.tn.popover';

export class AccountYourFontsController {
    families = {};
    groupBy = 'family';
    licenses = this.licenseService.getLicensesFromServer();
    filteredLicenses = this.licenseService.getFilteredLicenses();
    sortedLicenses: IDjangoApi1License[] = [];
    activeFilters: { licenseType?: LicenseType[] } = this.filterService.get();
    noLicenses = false;
    licensesLoaded = false;
    hasWebLicenseSelfHosted = false;

    upgradeRenewPopover = this.$tnPopover.popoverXS(
        angular.element('.popover-upgrade-renew-licenses'),
        false
    );
    subsetPopover = this.$tnPopover.popoverXS(
        angular.element('.popover-subset-selector'),
        false
    );

    static $inject = [
        'tnLicenseService',
        'tnFontFilterServiceAccountYourFonts',
        '$tnPopover',
        '$scope',
        'FontFamilyService',
    ];
    constructor(
        protected licenseService: LicenseService,
        protected filterService: FilterService2,
        protected $tnPopover: PopoverService,
        $scope: IScope,
        protected familyService: FontFamilyService
    ) {
        this.licenses.then((licenses) => {
            this.noLicenses = licenses.length === 0;
            this.licensesLoaded = true;
            licenseService.setFilteredLicenses({}, licenses);
            const familyIds = licenses
                .map((license) => license.style.family)
                .filter((familyId, i, arr) => {
                    return arr.lastIndexOf(familyId) === i;
                });

            familyService
                .list({ id: familyIds, page_size: 10000 })
                .then(({ results: families }) => {
                    families.forEach(
                        (family) => (this.families[family.id] = family)
                    );
                });
            this.hasWebLicenseSelfHosted = hasWebLicenseSelfHosted(licenses);
        });

        $scope.$watch(
            'vm.filteredLicenses',
            (newLicenses: IDjangoApi1License[]) => {
                this.sortedLicenses.splice(0, this.sortedLicenses.length);
                this.sortedLicenses.push(...newLicenses);
                this.sortedLicenses.sort((a, b) =>
                    licenseService.sortByName(a, b)
                );
            },
            true
        );
    }

    showLicenseType(
        licenses: IDjangoApi1License[],
        type: DjangoLicenseType
    ): boolean {
        // If the type is filtered out
        const licenseType = this.activeFilters.licenseType;
        if (
            licenseType &&
            licenseType.length !== 4 &&
            licenseType.length !== 0 &&
            licenseType.indexOf(type) === -1
        ) {
            return false;
        }
        if (hasAnyOfLicenseType(licenses, type)) {
            return true;
        }

        return false;
    }

    hasNonPerpetualLicense(
        licenses: IDjangoApi1License[],
        licenseType: DjangoLicenseType
    ): boolean {
        const _licenses = filterLicensesToType(licenses, licenseType);
        return hasNonPerpetualLicense(_licenses);
    }

    hasLimitedLicense(
        licenses: IDjangoApi1License[],
        licenseType: DjangoLicenseType
    ): boolean {
        const _licenses = filterLicensesToType(licenses, licenseType);
        return hasLimitedLicense(_licenses);
    }

    hasUpgradeableLicense(
        licenses: IDjangoApi1License[],
        licenseType: DjangoLicenseType
    ): boolean {
        const _licenses = filterLicensesToType(licenses, licenseType);
        return hasUpgradeableLicense(_licenses);
    }

    showUpgradeRenewPopover(
        $event: Event,
        licenses: IDjangoApi1License[],
        licenseType: DjangoLicenseType
    ): void {
        $event.stopPropagation();

        if (allAreUnpaid(licenses, licenseType)) {
            return;
        }
        let popoverLicenses;
        if (!this.hasLimitedLicense(licenses, licenseType)) {
            popoverLicenses = hasFurtherUpgrades(licenses, licenseType);
        } else {
            popoverLicenses = hasBeenPaid(licenses, licenseType);
            popoverLicenses = hasLimitedQty(popoverLicenses, licenseType);
        }
        angular
            .element('.popover-upgrade-renew-licenses')
            .controller()
            .initialize(null, popoverLicenses, [licenseType]);

        this.upgradeRenewPopover.show($event.currentTarget);
        this.upgradeRenewPopover.firstClick = false;
    }

    showSubsetPopover(
        $event: Event,
        licenses: IDjangoApi1License[],
        type: DjangoLicenseType = 'web'
    ): void {
        $event.stopPropagation();
        const popoverLicenses =
            type === 'web'
                ? hasSelfHostedLicenseList(licenses)
                : hasLicenseType(licenses, type);
        angular
            .element('.popover-subset-selector')
            .controller()
            .initialize(popoverLicenses, type === 'web');
        this.subsetPopover.show($event.currentTarget);
        this.subsetPopover.firstClick = false;
    }
}
